<div class="app-container" [ngClass]="{'error-page-shown': errorPageShown === true}">
  <router-outlet></router-outlet>
  <app-scroll-to-top
    class="to-top"
    [ngClass]="{'show-scrollTop': windowScrolled}"
    (scrollToTop)="onScrollToTop()"
  >
  </app-scroll-to-top>
</div>
